import { faMegaphone } from '@fortawesome/pro-duotone-svg-icons';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { CardEmptyState, EmptyStateIcon } from 'components/atoms/empty-state';
import { useIsNativeUser } from 'hooks/use-user-type';

const EmptyMessage = ({ projectId }) => {
  const isNativeUser = useIsNativeUser();

  return (
    <>
      <FormattedMessage
        id="project.overview.status_updates.empty.help_text"
        values={{ isNativeUser }}
      />{' '}
      {isNativeUser && (
        <a
          href={`/projects/${projectId}/status-updates`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FormattedMessage id="project.overview.status_updates.empty.cta" />
        </a>
      )}
    </>
  );
};

export const EmptyContent: FC<{ projectId: number }> = ({ projectId }) => (
  <CardEmptyState
    image={<EmptyStateIcon icon={faMegaphone} />}
    message={<EmptyMessage projectId={projectId} />}
  />
);
